import type { JSX } from 'react'

export const ChatIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use
      href='#chatIcon'
      height='100%'
      width='100%'
      fillOpacity={!filled ? 1 : 0}
    />
    <use
      href='#chatSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
